import { withAuth } from '../../auth';
import { PerformancePage } from '../../Performance';

const PerformanceWithAuth = withAuth(PerformancePage);

export default PerformanceWithAuth;
